// Formato único de la "fecha de liquidar" (tramite.fechaInicioEstimada) en pantalla: mes y año,
// que es la precisión real del dato — el cliente dice "vuelvo en marzo", no un día exacto.
// Se usa en la ficha del trámite y en la ficha de atención para que digan lo mismo.
export function formatearMesAnio(fechaIso) {
    if (!fechaIso) return '';
    const fecha = new Date(`${fechaIso}T00:00:00`);
    if (Number.isNaN(fecha.getTime())) return '';
    return fecha.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
}

export default formatearMesAnio;
